import React from "react";
import {
	Link,
	Text,
	VerticalList,
	Card,
	Button,
	Grid,
	Col,
} from "@website-builder/ui/shared/elements";
import Portfolio from "./Portfolio";
import { PortfolioShowcaseWrapper, ListItemWrapper } from "./style";
import {
	handleCTAClick,
	formatColor,
} from "@website-builder/utilities/utils/DesignUtils.js";
import { BUTTON_INTERACTION } from "@website-builder/utilities/constants/click-events.js";

const PortfolioShowcase = (props) => {
	const {
		sectionLabel,
		title,
		description,
		list,
		isDarkBackground = false,
		listHeader,
		cta,
		portfolioHeader,
		portfolios = [],
		cardColorInDarkBg = "var(--primary-forest-400)",
		cardColorInLightBg = "var(--primary-green-50)",
		pageSection,
		outerBackgroundColor = null,
		innerBackgroundColor = null,
		iconColor,
	} = props;
	const iconConfig = {
		iconName: "checkCircle",
		stroke: formatColor(iconColor) || "var(--primary-forest-400)",
		size: "1.5rem",
	};
	const cardColor = formatColor(innerBackgroundColor);
	return (
		<PortfolioShowcaseWrapper
			className="portfolio-showcase outer-margin-wrap"
			isDarkBackground={isDarkBackground}
			color={outerBackgroundColor}
		>
			<Grid className="top-content">
				<Col start={2} span={4} mdStart={1} mdSpan={6} className="left-section">
					<div>
						<Text
							dark={isDarkBackground}
							className="section-label"
							variant="label_M"
						>
							{sectionLabel}
						</Text>
						<Text
							dark={isDarkBackground}
							className="title"
							variant="headline_3"
							tag="h2"
						>
							{title}
						</Text>
						<Text
							dark={isDarkBackground}
							className="description rich-text-wrapper"
							tag="div"
							dangerouslySetInnerHTML={{ __html: description }}
						/>
						{cta?.buttonText ? (
							<Button
								{...cta}
								onClick={() =>
									handleCTAClick(cta, {
										page_section: pageSection,
										redirect_to: cta?.link?.link,
										click_text: cta.buttonText,
									})
								}
								className="link-desktop"
								type={cta?.type}
								darkBg={cta?.darkBg}
								buttonText={cta?.buttonText}
								disabled={cta?.disabled}
							/>
						) : null}
					</div>
				</Col>
				<Col
					start={7}
					span={5}
					mdStart={1}
					mdSpan={6}
					className="right-section"
				>
					{list?.length ? (
						<>
							<Text
								dark={isDarkBackground}
								className="list-header"
								variant="paragraph_M_bold"
							>
								{listHeader}
							</Text>
							<VerticalList
								separator
								seperatorColor="var(--secondary-gray-medium)"
								iconConfig={iconConfig}
								listItems={list.map(({ itemDescription = "" }, index) => {
									return (
										<ListItemWrapper
											key={index}
											isDarkBackground={isDarkBackground}
										>
											<Text
												dark={isDarkBackground}
												className="item-description"
												variant="paragraph_S"
												tag="div"
											>
												<div
													className="rich-text-wrapper"
													dangerouslySetInnerHTML={{ __html: itemDescription }}
												></div>
											</Text>
										</ListItemWrapper>
									);
								})}
								gap="1.5rem"
								darkBg={isDarkBackground}
							/>
						</>
					) : null}
				</Col>
			</Grid>
			{cta?.buttonText ? (
				<div className="link-mobile-container">
					<Link
						className="link link-text link-mobile"
						href={cta?.link?.link}
						target={cta?.link?.target}
						onClick={(e) =>
							handleCTAClick(
								cta,
								{
									page_section: pageSection,
									redirect_to: cta?.link?.link,
									click_text: cta.buttonText,
									event: BUTTON_INTERACTION.LINK_CLICK,
								},
								{},
								e,
							)
						}
						arrowCta
						disabled={cta?.disabled}
						darkBg={cta?.darkBg}
					>
						<Text
							dark={isDarkBackground}
							className="link-text link-mobile"
							variant="paragraph_M_bold"
						>
							{cta.buttonText}
						</Text>
					</Link>
				</div>
			) : null}
			{portfolios && portfolios?.length ? (
				<Card
					className="card-container"
					bgColor={
						cardColor ||
						(isDarkBackground
							? `var(--theme-primary-light, ${cardColorInDarkBg}99)`
							: `var(--theme-primary-light, ${cardColorInLightBg}99)`)
					}
				>
					{portfolioHeader ? (
						<Grid className="portfolio-header-grid">
							<Col start={2} span={10} mdStart={1} mdSpan={6}>
								<Text
									dark={isDarkBackground}
									className="header"
									variant="headline_6"
									tag="h3"
								>
									{portfolioHeader}
								</Text>
							</Col>
						</Grid>
					) : null}
					<Grid className="portfolio-container">
						{portfolios.map((portfolio, index) => {
							return (
								<Col
									start={index % 2 ? 7 : 2}
									span={5}
									mdStart={1}
									mdSpan={6}
									className="portfolio-grid-col"
									key={index}
								>
									<Portfolio
										isDarkBackground={isDarkBackground}
										className="portfolio-item"
										pageSection={pageSection}
										{...portfolio}
									/>
								</Col>
							);
						})}
					</Grid>
				</Card>
			) : null}
		</PortfolioShowcaseWrapper>
	);
};
export default PortfolioShowcase;
